import router from '@/modules/massPayment/router'
import { useMassPaymentStore } from '@/modules/massPayment/store'
import MassPaymentApi from '@/modules/massPayment/service'

export default {
  router,
  service: new MassPaymentApi(),
  store: useMassPaymentStore,
}
